import { render, staticRenderFns } from "./Altura.vue?vue&type=template&id=2b1ba9f7&scoped=true"
import script from "./Altura.vue?vue&type=script&lang=js"
export * from "./Altura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1ba9f7",
  null
  
)

export default component.exports